import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Config } from '../config';
import { StorageService } from '../../managers/storage.service';

@Injectable({
  providedIn: 'root'
})
export class YonduService extends Config {

  constructor(private httpClient: HttpClient,
    private storageService: StorageService) {
    super();
  }

  public sendMessage(obj: any) {
    let url;

    url = this.BASE_URL + "yondu_send_message";

    return this.httpClient.post(url, obj, this.storageService.getHeaders());
  }
}
